import script from "./QuickTopUpCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickTopUpCard.vue?vue&type=script&setup=true&lang=ts"

import "./QuickTopUpCard.vue?vue&type=style&index=0&id=1b94758d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b94758d"]])

export default __exports__